import React, { useEffect, useState } from "react";

const GuestDetailsPopup = ({
  rooms,
  removeRoom,
  onAdultIncrease,
  onAdultDecrease,
  toggleGuestDetailsPopup,
  addRoom,
  addChildAge,
  removeChild,
  availableAges,
  setIsguestDetails,
  buttonName,
}) => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {" "}
      {width > 640 && (
        <div className="guest_details_hotels_flex">
          {rooms?.slice(0, 6)?.map((room, index) => (
            <div className="guest_details_hotel" key={room.id}>
              {/* Room Title & Remove Button */}
              <div className="flex justify_content_between align_items_center mt-10">
                <h4>Room {index + 1}</h4>
                {rooms.length > 1 && (
                  <button
                    type="button"
                    style={{
                      fontSize: "12px",
                      fontWeight: "400",
                      color: "#EB442D",
                    }}
                    onClick={() => removeRoom(room.id)}
                  >
                    Remove
                  </button>
                )}
              </div>
              {/* Adults Selection */}
              <div className="agent">
                <span>Adult</span>
                <div className="flex align_items_center">
                  <button
                    type="button"
                    className={`optionButton ${room.adult <= 1 ? "disabled-button" : ""
                      }`}
                    onClick={() => onAdultDecrease(room.id)}
                  >
                    -
                  </button>
                  <input
                    className="optionCounterNumber"
                    value={room.adult}
                    min={1}
                    readOnly
                  />
                  <button
                    type="button"
                    className={`optionButton ${room.adult >= 4 ? "disabled-button" : ""
                      }`}
                    // disabled={room.adult >= 4}
                    onClick={() => onAdultIncrease(room.id)}
                  // className="optionButton optionCounterButtonWithBorder"
                  >
                    +
                  </button>
                </div>
              </div>
              {/* Child Selection */}{" "}
              {room.children.map((age, childIndex) => (
                <div key={childIndex}>
                  <div className="flex justify_content_between align_items_center mt-10">
                    <span>
                      Child <small>({age} Yrs)</small>
                    </span>
                    <button
                      className="remove_svg"
                      onClick={() => removeChild(room.id, childIndex)}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_6577_13294"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="18"
                          height="18"
                        >
                          <rect width="18" height="18" />
                        </mask>
                        <g mask="url(#mask0_6577_13294)">
                          <path d="M6.3 12.4903L9 9.79031L11.7 12.4903L12.4903 11.7L9.79031 9L12.4903 6.3L11.7 5.50969L9 8.20969L6.3 5.50969L5.50969 6.3L8.20969 9L5.50969 11.7L6.3 12.4903ZM9.00131 16.125C8.01581 16.125 7.0895 15.938 6.22237 15.564C5.35525 15.19 4.601 14.6824 3.95962 14.0413C3.31825 13.4002 2.81044 12.6463 2.43619 11.7795C2.06206 10.9128 1.875 9.98669 1.875 9.00131C1.875 8.01581 2.062 7.0895 2.436 6.22237C2.81 5.35525 3.31756 4.601 3.95869 3.95962C4.59981 3.31825 5.35375 2.81044 6.2205 2.43619C7.08725 2.06206 8.01331 1.875 8.99869 1.875C9.98419 1.875 10.9105 2.062 11.7776 2.436C12.6448 2.81 13.399 3.31756 14.0404 3.95869C14.6818 4.59981 15.1896 5.35375 15.5638 6.2205C15.9379 7.08725 16.125 8.01331 16.125 8.99869C16.125 9.98419 15.938 10.9105 15.564 11.7776C15.19 12.6448 14.6824 13.399 14.0413 14.0404C13.4002 14.6818 12.6463 15.1896 11.7795 15.5638C10.9128 15.9379 9.98669 16.125 9.00131 16.125Z" />
                        </g>
                      </svg>
                    </button>
                  </div>
                </div>
              ))}{" "}
              {/* Child Age Popup */}
              {/* Add Child Button */}
              <div className="relative">
                <div
                  className="flex align_items_center justify_content_between border"
                  style={{
                    padding: "10px",
                    margin: "10px 0",
                    fontWeight: "400",
                  }}
                  onClick={() => toggleGuestDetailsPopup(room.id)}
                >
                  Add a Child
                  <div>
                    {" "}
                    <svg
                      width="12"
                      height="6"
                      viewBox="0 0 12 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.99982 4.64202L10.3939 0.247911C10.5098 0.132021 10.6463 0.0755358 10.8033 0.0784526C10.9604 0.0814662 11.0969 0.140917 11.2128 0.256806C11.3287 0.372792 11.3866 0.509293 11.3866 0.666307C11.3866 0.82332 11.3287 0.95982 11.2128 1.07581L6.74693 5.55056C6.64144 5.65604 6.52327 5.73421 6.39241 5.78506C6.26155 5.8359 6.13069 5.86133 5.99983 5.86133C5.86896 5.86133 5.7381 5.8359 5.60724 5.78506C5.47638 5.73421 5.35821 5.65604 5.25272 5.55056L0.777825 1.07581C0.661936 0.959821 0.605499 0.821814 0.608513 0.661786C0.611527 0.501759 0.670978 0.3638 0.786867 0.247911C0.902756 0.132022 1.03926 0.0740781 1.19637 0.0740781C1.35338 0.0740781 1.48983 0.132022 1.60572 0.247911L5.99982 4.64202Z"
                        fill="#1C1B1F"
                      />
                    </svg>
                  </div>
                </div>{" "}
                {room.showGuestDetailsPopup && (
                  <div className="new_guest_details_popup mt-2 bg-white p-4 shadow-lg rounded-lg">
                    {availableAges.map((age, i) => (
                      <div
                        className="new-age-option"
                        key={i}
                        onClick={() => addChildAge(room.id, age)}
                        style={{ fontWeight: "400" }}
                      >
                        {age} Years
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {/* Add Room Button */}
              {rooms.length < 6 && index === 0 && (
                <div className="flex justify_content_end">
                  {" "}
                  <button
                    onClick={addRoom}
                    type="button"
                    style={{
                      color: "#009A50",
                      fontWeight: "400",
                    }}
                  >
                    Add a Room
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {width <= 640 && (
        <div className="bg_back_drop_overlay">
          <div className="mobile_details_hotels_flex">
            <div className="sticky_heading_top">
              <svg
                onClick={() => setIsguestDetails(false)}
                width="15"
                height="15"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.12203 20L0 18.878L8.87797 10L0 1.12203L1.12203 0L10 8.87797L18.878 0L20 1.12203L11.122 10L20 18.878L18.878 20L10 11.122L1.12203 20Z"
                  fill="#1C1B1F"
                />
              </svg>
              <h4>Travellers</h4>
              <div></div>
            </div>
            {rooms?.slice(0, 6)?.map((room, index) => (
              <div className="guest_details_hotel" key={room.id}>
                {/* Room Title & Remove Button */}
                <div className="flex justify_content_between align_items_center">
                  <h4>Room {index + 1}</h4>
                  {rooms.length > 1 && (
                    <button
                      type="button"
                      style={{
                        fontSize: "12px",
                        fontWeight: "400",
                        color: "#EB442D",
                      }}
                      onClick={() => removeRoom(room.id)}
                    >
                      Remove
                    </button>
                  )}
                </div>

                {/* Adults Selection */}
                <div className="agent">
                  <span>Adult</span>
                  <div className="flex align_items_center">
                    <button
                      type="button"
                      className={`optionButton ${room.adult <= 1 ? "disabled-button" : ""
                        }`}
                      onClick={() => onAdultDecrease(room.id)}
                    >
                      -
                    </button>
                    <input
                      className="optionCounterNumber"
                      value={room.adult}
                      min={1}
                      readOnly
                    />
                    <button
                      type="button"
                      disabled={room.adult >= 6}
                      onClick={() => onAdultIncrease(room.id)}
                      className="optionButton optionCounterButtonWithBorder"
                    >
                      +
                    </button>
                  </div>
                </div>

                {/* Child Selection */}
                <div>
                  {" "}
                  {room.children.map((age, childIndex) => (
                    <div key={childIndex}>
                      <div className="flex justify_content_between align_items_center mt-10">
                        <span>
                          Child <small>({age} Yrs)</small>
                        </span>
                        <button
                          className="remove_svg"
                          onClick={() => removeChild(room.id, childIndex)}
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <mask
                              id="mask0_6577_13294"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="18"
                              height="18"
                            >
                              <rect width="18" height="18" />
                            </mask>
                            <g mask="url(#mask0_6577_13294)">
                              <path d="M6.3 12.4903L9 9.79031L11.7 12.4903L12.4903 11.7L9.79031 9L12.4903 6.3L11.7 5.50969L9 8.20969L6.3 5.50969L5.50969 6.3L8.20969 9L5.50969 11.7L6.3 12.4903ZM9.00131 16.125C8.01581 16.125 7.0895 15.938 6.22237 15.564C5.35525 15.19 4.601 14.6824 3.95962 14.0413C3.31825 13.4002 2.81044 12.6463 2.43619 11.7795C2.06206 10.9128 1.875 9.98669 1.875 9.00131C1.875 8.01581 2.062 7.0895 2.436 6.22237C2.81 5.35525 3.31756 4.601 3.95869 3.95962C4.59981 3.31825 5.35375 2.81044 6.2205 2.43619C7.08725 2.06206 8.01331 1.875 8.99869 1.875C9.98419 1.875 10.9105 2.062 11.7776 2.436C12.6448 2.81 13.399 3.31756 14.0404 3.95869C14.6818 4.59981 15.1896 5.35375 15.5638 6.2205C15.9379 7.08725 16.125 8.01331 16.125 8.99869C16.125 9.98419 15.938 10.9105 15.564 11.7776C15.19 12.6448 14.6824 13.399 14.0413 14.0404C13.4002 14.6818 12.6463 15.1896 11.7795 15.5638C10.9128 15.9379 9.98669 16.125 9.00131 16.125Z" />
                            </g>
                          </svg>
                        </button>
                      </div>
                    </div>
                  ))}{" "}
                </div>

                {/* Add Child Button */}
                <div className="relative">
                  <div
                    className="flex align_items_center justify_content_between border"
                    style={{
                      padding: "10px",
                      margin: "10px 0",
                      fontWeight: "400",
                    }}
                    onClick={() => toggleGuestDetailsPopup(room.id)}
                  >
                    Add a Child
                    <div>
                      {" "}
                      <svg
                        width="12"
                        height="6"
                        viewBox="0 0 12 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.99982 4.64202L10.3939 0.247911C10.5098 0.132021 10.6463 0.0755358 10.8033 0.0784526C10.9604 0.0814662 11.0969 0.140917 11.2128 0.256806C11.3287 0.372792 11.3866 0.509293 11.3866 0.666307C11.3866 0.82332 11.3287 0.95982 11.2128 1.07581L6.74693 5.55056C6.64144 5.65604 6.52327 5.73421 6.39241 5.78506C6.26155 5.8359 6.13069 5.86133 5.99983 5.86133C5.86896 5.86133 5.7381 5.8359 5.60724 5.78506C5.47638 5.73421 5.35821 5.65604 5.25272 5.55056L0.777825 1.07581C0.661936 0.959821 0.605499 0.821814 0.608513 0.661786C0.611527 0.501759 0.670978 0.3638 0.786867 0.247911C0.902756 0.132022 1.03926 0.0740781 1.19637 0.0740781C1.35338 0.0740781 1.48983 0.132022 1.60572 0.247911L5.99982 4.64202Z"
                          fill="#1C1B1F"
                        />
                      </svg>
                    </div>
                  </div>{" "}
                  {room.showGuestDetailsPopup && (
                    <div className="new_guest_details_popup mt-2 bg-white p-4 shadow-lg rounded-lg">
                      {availableAges.map((age, i) => (
                        <div
                          className="new-age-option"
                          key={i}
                          onClick={() => addChildAge(room.id, age)}
                          style={{ fontWeight: "400" }}
                        >
                          {age} Years
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
            {rooms.length < 6 && (
              <button onClick={addRoom} type="button" className="add_room_btn">
                <svg
                  fill="#009a50"
                  height="15px"
                  width="15px"
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 27.963 27.963"
                  stroke="#009a50"
                >
                  <g id="SVGRepo_bgCarrier" strokeWidth="0" />

                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />

                  <g id="SVGRepo_iconCarrier">
                    {" "}
                    <g>
                      {" "}
                      <g id="c140__x2B_">
                        {" "}
                        <path d="M13.98,0C6.259,0,0,6.26,0,13.982s6.259,13.981,13.98,13.981c7.725,0,13.983-6.26,13.983-13.981 C27.963,6.26,21.705,0,13.98,0z M21.102,16.059h-4.939v5.042h-4.299v-5.042H6.862V11.76h5.001v-4.9h4.299v4.9h4.939v4.299H21.102z " />{" "}
                      </g>{" "}
                      <g id="Capa_1_9_"> </g>{" "}
                    </g>{" "}
                  </g>
                </svg>{" "}
                Add a Room
              </button>
            )}
            <div className="sticky_heading_bottom">
              <button type="submit">
                {buttonName}
                <span>
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <mask
                      id="mask0_6818_5962"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="15"
                      height="15"
                    >
                      <rect width="15" height="15" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_6818_5962)">
                      <path
                        d="M10.3919 7.96851H3.28125C3.14823 7.96851 3.03687 7.92361 2.94719 7.83382C2.8574 7.74414 2.8125 7.63278 2.8125 7.49976C2.8125 7.36674 2.8574 7.25539 2.94719 7.1657C3.03687 7.07591 3.14823 7.03101 3.28125 7.03101H10.3919L7.16109 3.80023C7.06818 3.70731 7.02229 3.59856 7.02344 3.47398C7.02469 3.3494 7.07375 3.23861 7.17063 3.14164C7.2676 3.05111 7.3774 3.00424 7.5 3.00101C7.6226 2.99778 7.7324 3.04466 7.82938 3.14164L11.792 7.10429C11.8506 7.16283 11.8918 7.22455 11.9158 7.28945C11.9398 7.35434 11.9519 7.42445 11.9519 7.49976C11.9519 7.57507 11.9398 7.64518 11.9158 7.71007C11.8918 7.77497 11.8506 7.83669 11.792 7.89523L7.82938 11.8579C7.74281 11.9444 7.63563 11.9887 7.50781 11.9907C7.38 11.9927 7.2676 11.9484 7.17063 11.8579C7.07375 11.7609 7.02531 11.6496 7.02531 11.5238C7.02531 11.398 7.07375 11.2866 7.17063 11.1896L10.3919 7.96851Z"
                        fill="white"
                      />
                    </g>
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GuestDetailsPopup;
